// Create a new file, e.g., axios-plugin.js
// import { createApp } from "vue";
import axios from "axios";

const axiosPlugin = {
  install(app) {
    app.config.globalProperties.$axios = axios;
  },
};

export default axiosPlugin;
